'use client';

import { useState, useEffect } from 'react';
import HeroSection from './HeroSection';
import ServicesGrid from './ServicesGrid';
import QuoteCalculator from './QuoteCalculator';
import TestimonialCarousel from './TestimonialCarousel';
import ServiceAreaMap from './ServiceAreaMap';
import TrustBadges from './TrustBadges';
import Footer from './Footer';
import LanguageSwitcher from './LanguageSwitcher';

const HomepageInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <div className="pt-16">
          <div className="container mx-auto px-4 py-20">
            <div className="animate-pulse space-y-8">
              <div className="h-96 bg-surface rounded-2xl"></div>
              <div className="grid md:grid-cols-3 gap-6">
                <div className="h-64 bg-surface rounded-xl"></div>
                <div className="h-64 bg-surface rounded-xl"></div>
                <div className="h-64 bg-surface rounded-xl"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      {/* Language Switcher - Fixed Position */}
      <div className="fixed top-20 right-4 z-40">
        <LanguageSwitcher />
      </div>

      {/* Main Content */}
      <div className="pt-16">
        <HeroSection />
        <ServicesGrid />
        <QuoteCalculator />
        <TestimonialCarousel />
        <ServiceAreaMap />
        <TrustBadges />
        <Footer />
      </div>
    </div>
  );
};

export default HomepageInteractive;